/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum StampRowType {
  TagDefinition = 'TagDefinition',
  TagGroupDefinition = 'TagGroupDefinition'
}
